module.exports = __webpack_public_path__ + "static/marbarahona.logo-edcce741fdf9ea8dfa1204c9a4f26250.png";